module.exports = __webpack_public_path__ + "2fed82fc255870cc7c1b2df73efff9f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-graduation-s.png
// module id = 2264
// module chunks = 0